// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__bc60f03bfd3d87b44575","cls2":"AuthorHeader-cls2___5f0a2c4a203c7e4331c AuthorHeader-cls1__bc60f03bfd3d87b44575"};